"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_CLASSNAME = exports.PACKAGE = exports.DOMAIN = exports.COZY_STATIC_MAJOR_VERSION = exports.COZY_BASE_CLASSNAME = exports.ASSET = void 0;
var THEME_CLASSNAME = exports.THEME_CLASSNAME = 'cozy__theme'; // TODO: Kept to avoid breaking changes

var DOMAIN = exports.DOMAIN = 'https://cozy-assets.quintoandar.com.br';
var PACKAGE = exports.PACKAGE = 'cozy-static';
var COZY_STATIC_MAJOR_VERSION = exports.COZY_STATIC_MAJOR_VERSION = 'v4';
var ASSET = exports.ASSET = 'illustrations';
var COZY_BASE_CLASSNAME = exports.COZY_BASE_CLASSNAME = 'Cozy__';